import { toNum } from "@/lib/utils";

/** Estado persistido en API; en Comprobantes se muestra FX, no “Negro”. */
export const ESTADO_FX_API = "Confirmado - Negro";
export const ESTADO_FX_LABEL = "Confirmado - FX";
export const ESTADO_CAE = "Confirmado - CAE/AFIP";
export const ESTADO_PENDIENTE = "Pendiente";

export function isEstadoFx(estado: string | null | undefined): boolean {
  const s = String(estado || "").toLowerCase();
  return s.includes("negro") || s.includes("confirmado - fx") || s.endsWith(" fx");
}

export function isEstadoCae(estado: string | null | undefined): boolean {
  const s = String(estado || "").toLowerCase();
  return s.includes("cae");
}

/** Negro → FX. El resto se muestra tal cual. */
export function labelEstadoComprobante(estado: string | null | undefined): string {
  if (!estado) return "";
  if (isEstadoFx(estado)) return ESTADO_FX_LABEL;
  return estado;
}

/**
 * Suma numérica de importes. `total` llega string (Decimal JSON) y `sum + f.total`
 * concatenaba ("$0111543.04…"). Estado de cuenta ya usa toNum.
 */
export function sumComprobantesTotal(
  facturas: Array<{ total?: string | number | null }>,
): number {
  return facturas.reduce((sum, f) => sum + toNum(f.total), 0);
}

/**
 * Misma numeración CAE y FX = talonarios distintos: no colapsar por `numero`.
 * Preferir id; si no hay, tipo + número + fecha.
 */
/**
 * Búsqueda de Comprobantes. Número y nombre van a `search`.
 * FX / CAE / Pendiente van a `estado`, porque el listado no indexa la etiqueta.
 */
export function comprobanteListFilters(raw: string): { search?: string; estado?: string } {
  const q = raw.trim();
  if (!q) return {};
  const n = q.toLowerCase();
  if (
    n === "fx" ||
    n === "negro" ||
    n === "confirmado - fx" ||
    n === "confirmado - negro" ||
    n === "confirmado fx"
  ) {
    return { estado: ESTADO_FX_API };
  }
  if (n === "cae" || n === "confirmado - cae/afip" || n === "confirmado cae") {
    return { estado: ESTADO_CAE };
  }
  if (n === "pendiente") return { estado: ESTADO_PENDIENTE };
  return { search: q };
}

export function comprobanteRowKey(factura: {
  id?: number | string | null;
  tipoComprobante?: string | null;
  tipo_comprobante?: string | null;
  numero?: string | null;
  fecha?: string | null;
}): string {
  if (factura.id != null && String(factura.id) !== "") {
    return `id:${factura.id}`;
  }
  const tipo = factura.tipoComprobante || factura.tipo_comprobante || "sin-tipo";
  return `${tipo}:${factura.numero || ""}:${factura.fecha || ""}`;
}
